import { RemoveAllCookies } from '../utils/util.js';
import React, { Component } from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params }}
            />
        );
    }
    return ComponentWithRouterProp;
}

class Logout extends Component {
    constructor(props) {
        super(props);

        // Init state and local storage
        this.state = {
            "rows": [],
            "centerID": null,
            "email": null,
            "logpass": null,
        }
        
        // Clear all cookies
        RemoveAllCookies();
    }

    render = () => {
        return (
            <div className="wow">
                <div className="boxu" style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '48px', marginBottom: '12px' }}>👋</div>
                    <h2 className="signIn" style={{ marginBottom: '8px' }}>You're signed out</h2>
                    <p className="signInMessage" style={{ marginBottom: '24px' }}>
                        You've been securely logged out. See you next time.
                    </p>
                    <button
                        className="logSubmit"
                        onClick={() => this.props.router.navigate('/login')}
                    >
                        Sign In Again
                    </button>
                </div>
            </div>
        );
    };

}

export default withRouter(Logout)